import { render } from "./ExtraQuestionCheckBox.vue?vue&type=template&id=f87fbe3e&scoped=true"
import script from "./ExtraQuestionCheckBox.vue?vue&type=script&lang=js"
export * from "./ExtraQuestionCheckBox.vue?vue&type=script&lang=js"

import "./ExtraQuestionCheckBox.vue?vue&type=style&index=0&id=f87fbe3e&scoped=true&lang=scss"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f87fbe3e"]])

export default __exports__